// Created by Om Shrivastava on 31-07-24
import React, { useEffect, useRef, useState } from "react";
import topHeaderStyle from "./topHeader.module.css";
import { IoSearch } from "react-icons/io5";
import {
  getSettingDetailsApi,
  getSocialIconsApi,
  postSearchDataApi,
} from "../../Api/services";
import config, { baseURL } from "../../Api/config";
import { Link, useNavigate } from "react-router-dom";
import { FaMobileAlt } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";

export default function TopHeader() {
  const [settingDetail, setSettingDetails] = useState({});
  const [socialIconData, setSocialIconData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const searchContainerRef = useRef(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchSettingData();
    fetchSocialIconData();
  }, []);

  const fetchSettingData = async () => {
    try {
      const response = await getSettingDetailsApi();
      setSettingDetails(response.setting_details);
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    }
  };

  const fetchSocialIconData = async () => {
    try {
      const response = await getSocialIconsApi();
      setSocialIconData(response.social_icon_details);
    } catch (error) {
      console.error("Error fetching homepage details:", error);
    }
  };

  const handleInputChange = async (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    setErrorMessage("");
    if (term === "") {
      setSearchResults([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (searchTerm === "") {
      setErrorMessage("Please enter a search term.");
      setSearchResults([]);
    } else {
      const response = await postSearchDataApi({ search: searchTerm });
      if (response.length === 0) {
        setErrorMessage("Search result not found.");
        setSearchResults([]);
      } else {
        setSearchResults(response);
        setErrorMessage("");
      }
    }
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setSearchResults([]);
      setSearchTerm("");
      setErrorMessage("");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openProductDetails = (data) => {
    navigate("/search-product-details", { state: { searchData: data } });
  };

  return (
    <div className={`${topHeaderStyle.parentDiv} `}>
      {window.innerWidth <= 1200 && (
        <div className={`${topHeaderStyle.logoContainer} `}>
          {settingDetail?.logo?.length > 0 ? (
            <Link to="">
              <img
                src={config.baseURL + settingDetail?.logo}
                alt=""
                className={`${topHeaderStyle.logo}`}
              />
            </Link>
          ) : (
            ""
          )}
        </div>
      )}
      <div
        className={`${topHeaderStyle.socialIconsAndContactDetailsContainer}`}
      >
        {socialIconData?.length > 0 ? (
          <div className={topHeaderStyle.circleContainer}>
            {socialIconData.map((icon, index) => (
              <Link
                key={index}
                to={icon.link}
                target="_blank"
                className={`${topHeaderStyle.circle}`}
              >
                <img
                  src={baseURL + icon.logo}
                  style={{ width: "100%", height: "100%" }}
                />
              </Link>
            ))}
          </div>
        ) : null}

        <div className={topHeaderStyle.contactContainer}>
          {settingDetail?.business_contact_number ? (
            <div className={topHeaderStyle.contactField1}>
              <IoCall style={{ fontSize: "12px", paddingTop: "3px" }} />
              <b
                className={topHeaderStyle.titleOfContacts}
                style={{ fontWeight: "500" }}
              >
                {" "}
                Contact Number :{" "}
              </b>
              <span>{settingDetail?.business_contact_number}</span>
            </div>
          ) : null}
          {settingDetail?.career_contact_number ? (
            <div className={topHeaderStyle.contactField2}>
              <FaMobileAlt style={{ fontSize: "12px" }} />{" "}
              <b
                className={topHeaderStyle.titleOfContacts}
                style={{ fontWeight: "500" }}
              >
                For Career :
              </b>{" "}
              <span>{settingDetail?.career_number}</span>
            </div>
          ) : null}
          {settingDetail?.email || settingDetail?.second_email ? (
            <div className={topHeaderStyle.contactField3}>
              <MdEmail style={{ fontSize: "12px", paddingTop: "3px" }} />
              <b
                className={topHeaderStyle.titleOfContacts}
                style={{ fontWeight: "500" }}
              >
                {" "}
                Email :{" "}
              </b>
              <span> {settingDetail?.email}</span>
              {settingDetail?.email && settingDetail?.second_email ? (
                <> || </>
              ) : null}
              <span> {settingDetail?.second_email}</span>
            </div>
          ) : null}
        </div>
        <div className={topHeaderStyle.countryFlagContainer1}>
          <img src="/india_flag.PNG" className={`${topHeaderStyle.flagIcon}`} />
        </div>
      </div>
    </div>
  );
}
